import {
  AriaAttributes,
  CSSProperties,
  ElementType,
  PropsWithChildren,
} from 'react'
import { VariantProps, tv } from 'tailwind-variants'

const typographyV = tv({
  variants: {
    type: {
      display: 'text-5xl',
      headingOne: 'text-4xl md:text-6xl lg:text-8xl',
      headingTwo: 'text-2xl lg:text-7xl',
      headingThree: 'text-xl text-[4rem]',
      headingFour: 'text-5xl',
      headingFive: 'text-4xl',
      headingSix: 'text-3xl',
      // subtitle
      subtitleOne: 'text-2xl',
      subtitleTwo: 'text-base lg:text-xl',
      // body
      bodyOne: 'text-base',
      bodyTwo: 'text-sm',
      bodyThree: 'text-xs',
      // button
      button: 'text-sm',
      buttonLarge: 'text-base',
      buttonSmall: 'text-xs',
      // caption
      caption: 'text-xs',
      // number
      numberOne: 'text-5xl',
      numberTwo: 'text-[2.5rem]',
      numberThree: 'text-base',

      // table
      labelTable: 'text-[1.1rem]',

      title: 'text-base lg:text-lg',
      label: 'text-[0.6875rem]',
      exponencial: 'text-[0.625rem]',
    },
    weight: {
      light: 'font-light',
      regular: 'font-normal',
      medium: 'font-medium',
      semibold: 'font-semibold',
      bold: 'font-bold',
      'extra-bold': 'font-extrabold',
    },
    font: {
      outfit: 'font-outfit',
      oxanium: 'font-oxanium',
      poppins: 'font-poppins',
      orbitron: 'font-orbitron',
    },
  },
  defaultVariants: {
    font: 'outfit',
    weight: 'regular',
  },
})

type TTypographyProps = PropsWithChildren<
  AriaAttributes & {
    as?: ElementType
    className?: string
    title?: string
    style?: CSSProperties
  } & VariantProps<typeof typographyV>
>

export function Typography({
  as: Component = 'p',
  className,
  type,
  weight,
  font,
  children,
  style,
  ...props
}: TTypographyProps) {
  return (
    <Component
      style={style}
      className={typographyV({ type, weight, font, className })}
      {...props}>
      {children}
    </Component>
  )
}
